import { observable, computed, action } from "mobx";
import { api, apiClient, debug } from "aaa";
import * as _ from "lodash";

export interface IUploadData {
    uid: string;
    file: string;
    absolutePath: string;
}

export interface IAttachment {
    file: File;
    uploadData?: IUploadData;
}

export class Attachments {
    @observable
    attachments: IAttachment[] = [];

    @observable uploading = false;
    @observable deleting = false;

    /**
     * Check if file with same name, size and modified data was uploaded already
     */
    attachmentExists(file: File): boolean {
        return _.find(this.attachments, entry =>
            entry.file.name === file.name
            && entry.file.size === file.size
            && entry.file.lastModifiedDate.getTime() === file.lastModifiedDate.getTime()
        ) !== undefined;
    }

    addFile(file: File) {
        let attachment: IAttachment = {
            file: file
        };

        const attachments = [...this.attachments];
        attachments.push(attachment);
        this.attachments = attachments;
    }

    async uploadAll() {

        try {
            this.uploading = true;
            await Promise.all(this.attachments.map(async attachment => {
                if (attachment.uploadData === undefined) {
                    const file = attachment.file;
                    const request = api.postAttachment(file);
                    try {
                        debug.log("### Uploading file", file);
                        const response = await apiClient.uploadFormData(request);
                        attachment.uploadData = response[0];
                        debug.log("### Upload finished", attachment.uploadData);
                    } catch (error) {
                        throw error;
                    }
                }
            }));
            this.uploading = false;
        } catch (error) {
            this.uploading = false;
            throw error;
        }
    }

    async removeAttachment(attachment: IAttachment) {
        if (attachment.uploadData) {
            const request = api.deleteAttachment(attachment.uploadData.file);
            try {
                this.deleting = true;
                const response = await apiClient.request(request);
                this.deleting = false;
                debug.log("### Deleted attachment", attachment, response);
            } catch (error) {
                this.deleting = false;
                throw error;
            }
        }

        // Remove attachment from list
        const attachments = [...this.attachments];
        _.remove(attachments, (entry: IAttachment) => entry.file === attachment.file);
        this.attachments = attachments;
    }

    @action
    reset() {
        this.attachments = [];
        this.uploading = false;
        this.deleting = false;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/Attachment.ts